import {Component, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {NgClass, NgIf} from "@angular/common";

export interface GenericModalConfig {
    title: string;
    content: string;
    confirmText?: string;
    cancelText?: string;
    showCancelButton?: boolean;
    confirmButtonClass?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
}

@Component({
    selector: 'eil-generic-modal',
    templateUrl: './generic-modal-component.component.html',
    styleUrls: ['./generic-modal-component.component.scss'],
    imports: [
        NgClass,
        NgIf
    ],
    standalone: true
})
export class GenericModalComponent {
    @ViewChild('genericModalTemplate', {static: true})
    genericModalTemplateRef: TemplateRef<any>;

    title: string = '';
    content: string = '';
    confirmText: string = 'OK';
    cancelText: string = 'Cancel';
    showCancelButton: boolean = true;
    confirmButtonClass: string = 'btn btn-primary';

    private modalRef: BsModalRef;
    private config: GenericModalConfig;

    constructor(private modalService: BsModalService) {
    }

    show(config: GenericModalConfig): BsModalRef {
        this.config = config;
        this.title = config.title;
        this.content = config.content;
        this.confirmText = config.confirmText ?? 'OK';
        this.cancelText = config.cancelText ?? 'Cancel';
        this.showCancelButton = config.showCancelButton ?? true;
        this.confirmButtonClass = config.confirmButtonClass ?? 'btn btn-primary';


        const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true,

        };

        this.modalRef = this.modalService.show(this.genericModalTemplateRef, modalConfig);
        return this.modalRef;
    }

    onConfirm(): void {
        if (this.config?.onConfirm) {
            this.config.onConfirm();
        }
        this.modalRef?.hide();
    }

    onCancel(): void {
        if (this.config?.onCancel) {
            this.config.onCancel();
        }
        this.modalRef?.hide();
    }
}
